import type { ReviewCustomer, ReviewMedia } from './interfaces';

// Base URL for review media - should be configured based on environment
const MEDIA_BASE_URL = import.meta.env.VITE_REVIEW_MEDIA_URL || '';

/**
 * Converts ReviewMedia object to full URL
 * For now uses mediaKey directly as URL (assuming it's already a full URL in mock data)
 * In production, this should combine MEDIA_BASE_URL with mediaKey
 */
export const getMediaUrl = (media: ReviewMedia): string => {
  // If mediaKey is already a full URL (for mock data), return it directly
  if (media.url.startsWith('http')) {
    return media.url;
  }

  // Otherwise, combine with base URL
  return `${MEDIA_BASE_URL}/${media.mediaKey}`;
};

/**
 * Formats customer name for display
 * Returns "FirstName L." format
 */
export const formatCustomerName = (customer: ReviewCustomer): string => {
  const { firstName, lastName } = customer;
  const lastInitial = lastName ? `${lastName.charAt(0)}.` : '';
  return `${firstName} ${lastInitial}`.trim();
};

/**
 * Formats date string from ISO format to localized display
 */
export const formatReviewDate = (dateString: string, locale = 'ru'): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
};

/**
 * Gets video thumbnail URL (for video type media)
 * For now returns the same URL, but can be extended to return poster frame
 */
export const getVideoThumbnailUrl = (media: ReviewMedia): string => {
  return getMediaUrl(media);
};
